import MentoringCompletedPrograms from './MentoringCompletedPrograms.vue';

export default MentoringCompletedPrograms;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/views/completedprograms/index.ts